import { jsx as _jsx } from "react/jsx-runtime";
import { CoOwnershipType } from "./types";
import { BuildingIcon, CoinsIcon, GavelIcon } from "@gemini/icons";
export const CoOwnershipMapIcon = {
    [CoOwnershipType.numberOfUnits]: _jsx(BuildingIcon, {}),
    [CoOwnershipType.operatingCosts]: _jsx(CoinsIcon, {}),
    [CoOwnershipType.syndicProcedures]: _jsx(GavelIcon, {}),
};
